import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import NavMenu from './NavMenu.js';
import * as utils from './Utils.js'

const albums = [
  {
    'title': 'Rehearsal Dinner & Welcome Party',
    'info': 'Pictures from the rehearsal dinner and welcome party',
    'link': 'https://drive.google.com/drive/folders/1nmMYjt6vcoBSRHhoOSb1evHPFPlYq0qM?usp=sharing'
  },
  {
    'title': 'Wedding Day',
    'info': 'Pictures from the wedding day',
    'link': 'https://drive.google.com/drive/folders/1CtoEe6h5cd2NKIuBDSTHt1GukZUq_DlY?usp=sharing',
    'note': "We are still waiting for some photos to be edited and returned. Until then, enjoy some of the pictures that we do have, but note that this is not all of the pictures yet."
  }
]

const Pictures = () => {
  useEffect(() => {
  }, [])

  return (
    <div className="Pictures">
      <Helmet>
        <title>Pictures</title>
        <meta
          name="description"
          content="Check out pictures from the wedding weekend!"
        />

        <meta property="og:title" content="Pictures | Chandler & Anna" />
        <meta
          property="og:description"
          content="Check out pictures from the wedding weekend!"
        />
        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/registry.jpg"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta property="og:url" content="https://chandlerandanna.com/pictures" />

        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Pictures</p>
          <div className='pictures-intro'>
            <p className='wedding-page-info'>Thank you for celebrating our wedding with us. We had such an amazing time and it would not have been the same without you. Please enjoy pictures of the weekend. Try to find pictures of yourself to download!</p>
          </div>
          <div className='things-to-do-container'>
            <div id="albums" className='things-to-do-category'>
              <p className='things-to-do-category-title'>Albums</p>
              <div className='things-to-do-list'>
                {albums.map((album) => (
                  <div key={album.title} className='things-to-do-list-item'>
                    <p className='things-to-do-list-item-title'>{album.title}</p>
                    { album.note ? <p className='things-to-do-list-item-note blue'>{album.note}</p> : '' }
                    <div className='things-to-do-list-item-links'>
                      {album.info}
                    </div>
                    <div className='things-to-do-list-item-links'>
                      <a href={album.link || '#'} target="_blank" rel="noopener noreferrer">View Pictures</a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['blue', 'ivory']) }
      </div>
    </div>
  );
}

export default Pictures;
